import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import EditVirtualEventForm from './EditVirtualEventForm/EditVirtualEventForm';

import styles from './EditVirtualEventModal.module.less';
import { formatVirtualDateForEdit } from '../../../../util/formDataUtil';

const EditVirtualEventModal = ({ initialValues, onSubmit, onDelete, getAttireSuggestions }) => {
  const [showAttire, setShowAttire] = useState(false);

  const handleDelete = () => onDelete(initialValues.id);
  const toggleShowAttire = () => {
    setShowAttire(!showAttire);
  };
  const titleText = showAttire ? 'Most Common Attires Suggested By Zola Couples' : 'Edit Event';
  useEffect(() => {
    getAttireSuggestions();
  }, []);
  const formattedDate = formatVirtualDateForEdit(initialValues);
  const formattedInitialValues = Object.assign({}, initialValues, formattedDate);

  return (
    <div>
      {showAttire && (
        <button onClick={toggleShowAttire} className={styles.backButton}>
          &lsaquo; Back
        </button>
      )}
      <div className={styles.modalFormContainer}>
        <div className={styles.modalHeader}>
          <h3 className={styles.modalTitle}>{titleText}</h3>
        </div>
        <div className={styles.modalBody}>
          <EditVirtualEventForm
            onSubmit={onSubmit}
            initialValues={formattedInitialValues}
            handleDelete={handleDelete}
            toggleSuggestions={toggleShowAttire}
            showAttire={showAttire}
          />
        </div>
      </div>
    </div>
  );
};

EditVirtualEventModal.propTypes = {
  initialValues: PropTypes.shape({
    attire: PropTypes.string,
    type: PropTypes.string,
    name: PropTypes.string,
  }),
  onSubmit: PropTypes.func,
  onDelete: PropTypes.func,
};

export default EditVirtualEventModal;



// WEBPACK FOOTER //
// ./src/components/manage/common/EditVirtualEventModal/EditVirtualEventModal.jsx